import axios from "axios";
import { useEffect, useState } from "react";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert } from "../../Components/Alerts";
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import ContractForm from "./EmpComponents/ContractForm ";
import ContractDisplay from "./EmpComponents/ContractDisplay";
import { useParams } from "react-router-dom";
import { Button } from '@mui/material';
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";

export default function EmployeeContracts() {
    const { accountId } = useParams();

    const [showContractDisplay, setShowContractDisplay] = useState(false);

    const [contractData, setContractData] = useState(null);
    const [name, setName] = useState("");
    const [idNumber, setIdNumber] = useState("");
    const [empAddress, setEmpAddress] = useState("");

    const handleGenerateContract = (data, name, idnumber, address) => {
        setContractData(data);
        setName(name);
        setIdNumber(idnumber);
        setEmpAddress(address)
        setShowContractDisplay(true); // e shfaq display-n kur gjenerohet kontrata

    };
    return (
        <div className="container mx-auto p-4 md:p-8">
            <div className="max-w-4xl mx-auto">
                <Card>
                    {/* <CardHeader
                        title={<Typography variant="h5" component="div" align="center" fontWeight="bold">Kontrat Pune</Typography>}
                        subheader={<Typography variant="body2" color="text.secondary" align="center">Plotësoni të dhënat më poshtë për të gjeneruar një kontratë të re punësimi.</Typography>}
                    /> */}
                    <CardHeader
                        title={
                            <Typography variant="h5" component="div" align="center" fontWeight="bold">
                                Kontrat Pune
                            </Typography>
                        }
                        subheader={
                            <Typography variant="body2" color="text.secondary" align="center">
                                Plotësoni të dhënat më poshtë për të gjeneruar një kontratë të re punësimi.
                            </Typography>
                        }
                        action={
                            <LinkAndClickButton
                                text="Mbyll kontraten"
                                icon={<FaTimes />}
                                link="/accounts/employees"
                            />
                            // <Button
                            //     variant="outlined"
                            //     color="error"
                            //     onClick={() => setShowContractDisplay(false)}
                            // >
                            //     Mbyll Kontratën
                            // </Button>
                        }
                    />

                    <CardContent>
                        <ContractForm onGenerate={handleGenerateContract} onClearContract={() => setShowContractDisplay(false)} accountId={accountId} />
                    </CardContent>
                </Card>
                {/* <ContractDisplay
                    contractData={contractData}
                    name={name}
                    idnumber={idNumber}
                    empAddress={empAddress}
                /> */}
                {showContractDisplay && (
                    <ContractDisplay
                        contractData={contractData}
                        name={name}
                        idnumber={idNumber}
                        empAddress={empAddress}
                    />
                )}
            </div>
        </div>
    )
}